import { type ReactNode, useEffect, useState } from 'react';
import type { Creator } from '@/types';
import { useAuth } from '@/hooks/use-auth';
import { CreatorProfile } from './creator-profile';
import { DetailBody } from './creator-detail-body';
import { CreatorAiSection } from './creator-ai-section';
import type { DetailMode } from './creator-detail-sections';
import { useAcknowledgeAlert } from '../hooks/use-creator-alert';

function useAckOnOpen(creator: Creator): void {
  const { user, isCollector } = useAuth();
  const ack = useAcknowledgeAlert();
  const isOwner = !!user && creator.collector === user.id;
  // Solo auto-ack para alertas del admin (alerted_by con valor). Las
  // alertas de IA (alerted_by vacío) requieren acción explícita: apelar
  // o eliminar. Abrir el modal no las despeja por sí solo.
  const shouldAck =
    isCollector && isOwner && !!creator.alert_pending_at && !!creator.alerted_by;
  useEffect(() => {
    if (shouldAck) ack.mutate(creator.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creator.id]);
}

export function CreatorDetailContent({
  creator,
  onClose,
}: {
  creator: Creator;
  onClose: () => void;
}): ReactNode {
  const [mode, setMode] = useState<DetailMode>('view');
  useAckOnOpen(creator);
  return (
    <div>
      <CreatorProfile creator={creator} />
      <CreatorAiSection creator={creator} setMode={setMode} />
      <div className="border-t border-white/[0.06] mt-base pt-base">
        <DetailBody
          creator={creator}
          mode={mode}
          setMode={setMode}
          onClose={onClose}
        />
      </div>
    </div>
  );
}
